import { defineComponent as m, openBlock as l, createElementBlock as o, mergeProps as p, unref as e, renderSlot as u, createElementVNode as n, createCommentVNode as A } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, M = { key: 1 }, f = { key: 2 }, k = { key: 3 }, h = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconLetterCircleV"
}, C = /* @__PURE__ */ m({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = Z(s);
    return (i, t) => (l(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      u(i.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", g, t[0] || (t[0] = [
        n("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm43.14-111.54-32,80a12,12,0,0,1-22.28,0l-32-80a12,12,0,1,1,22.28-8.92L128,143.69l20.86-52.15a12,12,0,0,1,22.28,8.92Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", M, t[1] || (t[1] = [
        n("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM167.43,99l-32,80a8,8,0,0,1-14.86,0l-32-80A8,8,0,0,1,103.43,93L128,154.46,152.57,93A8,8,0,1,1,167.43,99Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", f, t[2] || (t[2] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm39.43,75-32,80a8,8,0,0,1-14.86,0l-32-80A8,8,0,0,1,103.43,93L128,154.46,152.57,93A8,8,0,1,1,167.43,99Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", k, t[3] || (t[3] = [
        n("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218ZM165.57,98.23l-32,80a6,6,0,0,1-11.14,0l-32-80a6,6,0,1,1,11.14-4.46L128,159.84l26.43-66.07a6,6,0,0,1,11.14,4.46Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", h, t[4] || (t[4] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM167.43,99l-32,80a8,8,0,0,1-14.86,0l-32-80A8,8,0,0,1,103.43,93L128,154.46,152.57,93A8,8,0,1,1,167.43,99Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", w, t[5] || (t[5] = [
        n("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220ZM163.71,97.49l-32,80a4,4,0,0,1-7.42,0l-32-80a4,4,0,1,1,7.42-3L128,165.23l28.29-70.72a4,4,0,1,1,7.42,3Z" }, null, -1)
      ]))) : A("", !0)
    ], 16));
  }
});
export {
  C as default
};
